import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import SvgArrowUp from "@/styles/icons/ArrowUp";

const findDefaultOpenItem = (sections: any[]) => {
  const cosmeticIdx = sections.findIndex(
    (s) => s.label.toLowerCase() === "cosmetic procedures"
  );
  if (cosmeticIdx === -1) return "";
  const items =
    sections[cosmeticIdx].items?.filter((item: any) => !item.parent) ?? [];
  const faceIdx = items.findIndex(
    (item: any) => item.label.toLowerCase() === "face"
  );
  return faceIdx === -1 ? "" : `s${cosmeticIdx}-item-${faceIdx}`;
};

export const NavigationMenu: React.FC = () => {
  const [menuSections, setMenuSections] = useState<any[]>([]);
  const [openItem, setOpenItem] = useState<string>("");

  useEffect(() => {
    fetch("/api/navigation-menu")
      .then((res) => res.json())
      .then((data) => {
        setMenuSections(data);
        setOpenItem(findDefaultOpenItem(data));
      });
  }, []);

  const getMenuLink = (href: string) => {
    return window.location.origin + href.replace("{slug}", "");
  };

  return (
    <div
      className="border-t-2 border-secondary desktop:flex w-full flex-wrap group-data-[shown=true]:overflow-auto group-data-[shown=false]:overflow-hidden"
      data-lenis-prevent
    >
      {menuSections.map((section, sIdx) => {
        let bg = "bg-accent-color-three";
        if (section.label.toLowerCase() === "cosmetic procedures") {
          bg = "bg-primary-dark";
        }
        return (
          <div
            key={section.id}
            className={`flex flex-col flex-1 py-12 px-6 md:px-12 gap-6 ${bg}`}
          >
            {section.slug ? (
              <a
                href={getMenuLink(section.slug)}
                className="font-sans text-span-large uppercase text-secondary-light whitespace-nowrap hover:opacity-70 transition-colors"
              >
                {section.label}
              </a>
            ) : (
              <span className="font-sans text-span-large uppercase text-secondary-light whitespace-nowrap">
                {section.label}
              </span>
            )}
            <div className="flex flex-col gap-6">
              {section.items
                ?.filter((item: any) => !item.parent)
                .map((item: any, idx: number) => {
                  const globalKey = `s${sIdx}-item-${idx}`;
                  return (
                    <div key={item.id}>
                      {item.has_subitems && item.subitems?.length > 0 ? (
                        <Accordion
                          type="single"
                          collapsible
                          className="w-full flex flex-col"
                          value={openItem === globalKey ? `item-${idx}` : ""}
                          onValueChange={(val) =>
                            setOpenItem(val ? globalKey : "")
                          }
                        >
                          <AccordionItem
                            value={`item-${idx}`}
                            className="!border-none bg-transparent"
                          >
                            <AccordionTrigger
                              icon={<SvgArrowUp className="transition-all" />}
                              className="text-[20px] leading-[28px] font-medium text-accent-color-two-light text-left hover:no-underline justify-normal py-0"
                            >
                              {item.label}
                            </AccordionTrigger>
                            <AccordionContent className="mt-4">
                              <ul className="flex flex-col gap-2 pl-4">
                                {item.subitems.map((subitem: any) => (
                                  <li key={subitem.id}>
                                    <a
                                      href={getMenuLink(subitem.href)}
                                      className="font-sans text-white hover:opacity-70 transition-all text-base"
                                    >
                                      {subitem.label}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </AccordionContent>
                          </AccordionItem>
                        </Accordion>
                      ) : (
                        <a
                          href={getMenuLink(item.href)}
                          className="text-accent-color-two-light hover:opacity-70 transition-colors text-lg font-sans"
                        >
                          {item.label}
                        </a>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>
        );
      })}
    </div>
  );
};
